import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  schema?: object;
  image?: string;
  type?: string;
  datePublished?: string;
  dateModified?: string;
}

export const SEO = ({ 
  title = "tellcasey – Automated Customer Interviews & Proof Generation",
  description = "tellcasey automates customer interviews and turns conversations into case studies, testimonials, quotes, and insights—no scheduling, writing, or agencies.",
  path = "/",
  schema,
  image = "https://tellcasey.com/og-image.jpg",
  type = "website",
  datePublished,
  dateModified
}: SEOProps) => {
  const url = `https://tellcasey.com${path}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="tellcasey" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Article metadata */}
      {datePublished && <meta property="article:published_time" content={datePublished} />}
      {dateModified && <meta property="article:modified_time" content={dateModified} />}
      
      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};
